import { createFilterOptions, TextField, Typography } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import PropTypes from 'prop-types';
import { addCandidateSource } from 'src/services/candidate.service';
import { useSnackbar } from 'notistack';
import { RHFAutocomplete } from '../hook-form';

const filter = createFilterOptions();

export const SourceInput = ({
  inputSourceFormatOptions,
  setInputSourceFormatOptions,
  methods,
}) => {
  // hooks
  const { organization } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();

  // variables
  const orgId = organization?.organization_id;

  // functions
  const addNewCandidateSource = async source => {
    try {
      const payload = {
        candidate_source: source,
      };

      const response = await addCandidateSource(orgId, payload);

      if (response.success) {
        setInputSourceFormatOptions(prev => [
          ...prev,
          {
            label: source,
            value: source,
          },
        ]);

        enqueueSnackbar('Source added successfully');
      } else {
        throw new Error(response.message);
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar({
        message: 'Error occured while adding source',
        variant: 'error',
      });
    }
  };

  return (
    <RHFAutocomplete
      name="source"
      options={
        inputSourceFormatOptions.length
          ? inputSourceFormatOptions.sort((a, b) =>
              a.label.localeCompare(b.label),
            )
          : []
      }
      getOptionLabel={option => {
        if (typeof option === 'string') {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
        return option.label;
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;

        const isExisting = options.some(
          option => inputValue.toLowerCase() === option.label.toLowerCase(),
        );

        if (inputValue !== '' && !isExisting) {
          filtered.push({
            inputValue,
            label: `Add "${inputValue}"`,
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      autoHighlight
      placeholder="Enter source"
      value={
        methods.watch('source')
          ? inputSourceFormatOptions.find(
              option => option.value === methods.watch('source'),
            ) || {
              label: `${methods.watch('source')}`,
              value: `${methods.watch('source')}`,
            }
          : { label: '', value: '' }
      }
      onChange={async (event, newValue) => {
        if (newValue?.inputValue) {
          await addNewCandidateSource(newValue.inputValue);
          methods.setValue('source', newValue.inputValue, {
            shouldValidate: true,
          });
        } else {
          methods.setValue('source', newValue?.value || '', {
            shouldValidate: true,
          });
        }
      }}
      renderOption={(props, option) => (
        <Typography component="li" variant="input" {...props}>
          {option.label}
        </Typography>
      )}
      renderInput={params => (
        <TextField
          sx={{
            fontSize: '0.875rem',
          }}
          placeholder="Eg. LinkedIn"
          onChange={e => {
            methods.setValue('source', e.target.value, {
              shouldValidate: true,
            });
          }}
          {...params}
        />
      )}
      sx={{
        minWidth: '200px',
      }}
    />
  );
};

SourceInput.propTypes = {
  inputSourceFormatOptions: PropTypes.array,
  setInputSourceFormatOptions: PropTypes.func,
  methods: PropTypes.object,
};
